import React, {Component} from "react";

import * as stringUtil from '../../util/stringUtil';

class TextInput extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.value !== nextProps.value
            || this.props.readOnly !== nextProps.readOnly
        )
    }

    handleChange(event) {
        const { id, onChange, type } = this.props;

        let value = event.target.value;
        if (type === 'number') {
            // value = Number(value);
            value = stringUtil.pureNumber(value);
        }

        onChange(id, value);
    }

    handleKeyDown(event) {
        const { onKeyDown } = this.props;

        if (event.key === 'Enter') {
            onKeyDown();
        }
    }

    render() {
        const { id, name, value, readOnly, disabled, className, placeholder, labelPlaceholder, fullWidth, width, multiline, rows, type, onClick, warning } = this.props;
        const { handleChange, handleKeyDown } = this;

        return (
            <React.Fragment>
                <>
                    {
                        rows <= 1 &&
                        <input
                            id={id}
                            className={warning ? className + ' border-danger' : className}
                            name={name}
                            type={type}
                            value={value}
                            disabled={disabled}
                            readOnly={readOnly}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            placeholder={placeholder}
                            onClick={onClick}
                        />
                    }
                    {
                        rows > 1 &&
                        <textarea
                            id={id}
                            className={warning ? className + ' border-danger' : className}
                            name={name}
                            value={value}
                            disabled={disabled}
                            readOnly={readOnly}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            placeholder={placeholder}
                            onClick={onClick}
                            rows={rows}
                            style={{"resize": "none"}}
                        >
                        </textarea>
                    }
                </>
                { labelPlaceholder && <label htmlFor={name}>{labelPlaceholder}</label> }
            </React.Fragment>
        )
    }
}

TextInput.defaultProps = {
    id: '',
    className: 'form-control d-inline',
    value: '',
    placeholder: '',
    labelPlaceholder: '',
    unit: null,
    fullWidth: true,
    width: "100%",
    disabled: false,
    multiline: false,
    rows: 1,
    type: 'input',
    readOnly: false,
    warning: false,
    onChange: function() {},
    onKeyDown: function() {},
    onClick: function () {},
}

export default TextInput;
